<user-resources-list [loaded]="loaded"
                     [resourcePermissionType]="resourcePermissionType"
                     [data]="data"
                     title="Views"
                     i18n-title="@@views">
</user-resources-list>
